import React, { useState, useEffect } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as yup from 'yup';
import InfoBasicInformation from './NewInfoForms/ContentBasicInformation';
import InfoHeader from './NewInfoForms/ContentHeader';
import InfoUpdateUpload from './NewInfoForms/ContentUpdateUpload';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { getContent, updateContent } from 'lib/apiService';
import ContentType from './NewInfoForms/ContentType';
import ContentDetails from './NewInfoForms/ContentDetails';
import FileUpload from './NewInfoForms/FileUpload';

const schema = yup
  .object({
    title: yup.string().required('Энэ талбарыг оруулна уу!'),
    description: yup.string().required('Энэ талбарыг оруулна уу!'),
    contentType: yup.string().required('Энэ талбарыг оруулна уу!')
  })
  .required();

const ContentUpdate = () => {
  let navigage = useNavigate();
  const { contentId } = useParams();

  // images
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fileLoading, setFileLoading] = useState(false);
  const [imageUrls, setImageUrls] = useState([]);
  const [pdfFiles, setPdfFiles] = useState([]);
  const [uploadFiles, setUploadFiles] = useState([]);

  const submittedValues = {};
  const methods = useForm({
    resolver: yupResolver(schema)
  });
  const { handleSubmit, reset } = methods;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getContent(contentId);
        const newData = response?.data?.data;

        reset({
          title: newData?.title,
          description: newData?.description,
          contentType: newData?.contentType
        });

        const newFile = {};
        Object.assign(newFile, {
          path: newData.image.public_id,
          preview: newData.image.url
        });

        setImageUrls([newData.image]);
        setFiles([newFile]);
        // pdf
        const newFilePDF = {};
        Object.assign(newFilePDF, {
          path: newData.file.public_id,
          preview: newData.file.url
        });

        setUploadFiles([newData.file]);
        setPdfFiles([newFilePDF]);
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };
    fetchData();
  }, [contentId]);

  const imageUploader = async image => {
    setLoading(true);

    const formData = new FormData();
    formData.append('file', image);
    formData.append('upload_preset', 'eruulmend'); // Replace with your upload preset

    const res = await fetch(
      'https://api.cloudinary.com/v1_1/dvhdmr8yi/image/upload',
      {
        method: 'POST',
        body: formData
      }
    );

    const data = await res.json();
    setImageUrls(prevUrls => [
      ...prevUrls,
      {
        url: data.secure_url,
        public_id: data.public_id,
        name: data.display_name
      }
    ]);

    setLoading(false);
  };

  const FileUploader = async image => {
    setFileLoading(true);

    const formData = new FormData();
    formData.append('file', image);
    formData.append('upload_preset', 'eruulmend'); // Replace with your upload preset

    const res = await fetch(
      'https://api.cloudinary.com/v1_1/dvhdmr8yi/image/upload',
      {
        method: 'POST',
        body: formData
      }
    );

    const data = await res.json();
    setUploadFiles(prevUrls => [
      ...prevUrls,
      {
        url: data.secure_url,
        public_id: data.public_id,
        name: data.display_name
      }
    ]);

    setFileLoading(false);
  };

  const onSubmit = data => {
    if (Object.keys(data).length === 0) {
      toast.warning('Та мэдээллээ гүйцэт оруулна уу', {
        theme: 'colored'
      });
    } else {
      data.image = imageUrls[0];
      data.file = uploadFiles[0];
      updateContent(contentId, data)
        .then(result => {
          if (result.data.success) {
            toast.success(`Амжиллтай засагдлаа`, {
              theme: 'colored'
            });
          }
        })
        .catch(error => {
          toast.warning(`${error.response.data.error.message}`, {
            theme: 'colored'
          });
        });
      const keys = Object.keys(data);
      for (const key of keys) {
        submittedValues[key] = '';
      }
      reset({ ...submittedValues });
      navigage('/content/content-list');
    }
  };

  const handleRemove = async path => {
    setFiles(files.filter(file => file.path !== path));

    const updatedImageUrls = imageUrls.filter(
      image => image.public_id !== path && image.uniqueId !== '200x200.jpg'
    );
    setImageUrls(updatedImageUrls);
    if (path) {
      axios
        .post(`${process.env.REACT_APP_FILE_URL}/removeimage`, {
          public_id: path,
          fileType: 'image'
        })
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          console.log('CLOUDINARY UPLOAD FAILED', error);
        });
      console.log('Image deleted successfully from S3.');
    }
  };

  const handleFileRemove = path => {
    let removeItem = '';
    uploadFiles.forEach(item => {
      if (item.bucketname === path) {
        removeItem = item.public_id;
      }
    });
    setPdfFiles(pdfFiles.filter(file => file.path !== path));
    const updatedPdfUrls = uploadFiles.filter(
      image => image.bucketname !== path
    );
    setUploadFiles(updatedPdfUrls);
    if (removeItem) {
      axios
        .post(`https://admin.gegeensoft.live/api/v1/images/removeimage`, {
          public_id: removeItem
        })
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          console.log('CLOUDINARY UPLOAD FAILED', error);
        });
    }
  };

  return (
    <FormProvider {...methods}>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row className="g-3">
          <Col xs={12}>
            <InfoHeader />
          </Col>
          <Col lg={8}>
            <InfoBasicInformation />

            <InfoUpdateUpload
              setFiles={setFiles}
              files={files}
              imageUploader={imageUploader}
              handleRemove={handleRemove}
              loading={loading}
            />
            <FileUpload
              setFiles={setPdfFiles}
              files={pdfFiles}
              fileUploader={FileUploader}
              handleRemove={handleFileRemove}
              loading={fileLoading}
            />
            <ContentDetails />
          </Col>
          <Col lg={4}>
            <div className="sticky-sidebar">
              <ContentType />
            </div>
          </Col>
        </Row>
      </Form>
    </FormProvider>
  );
};

export default ContentUpdate;
